export default "__VITE_ASSET__64a5b337__"